export default "/img/ML.ec7c04e0db2a8c195b310529c12311ad.png";